import type { ResolutionKind, ResolutionMessageType } from '@/library/message/enum';
import { MessageType, ResolutionType } from '@/library/message/enum';
import * as Locale from '@/plugins/i18n';

type ResolutionOptionText = {
  [key in ResolutionKind]: string;
};

export const RESOLUTION_OPTIONS_TEXT: Partial<Record<ResolutionMessageType, ResolutionOptionText>> = {
  [MessageType.RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.no') as string,
  },
  [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('chat.sys.msg.ai.overlong_resolution.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('chat.sys.msg.ai.overlong_resolution.no') as string,
  },
  [MessageType.STALE_AI_CONVERSATION_RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('chat.sys.msg.ai.stale_conversation_resolution.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('chat.sys.msg.ai.stale_conversation_resolution.no') as string,
  },
  [MessageType.VOICE_CONFIRMATION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.continue') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.cancel') as string,
  },
  [MessageType.LANDING_AI_VOICE_CONFIRMATION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.continue') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.cancel') as string,
  },
  [MessageType.VOICE_NATIVE_MICRO_ACCESS_CONFIRMATION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.continue') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.cancel') as string,
  },
  [MessageType.CANCEL_REQUEST]: {
    [ResolutionType.YES]: Locale.i18n.t('chat.sys.navigation.contact_support') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.end_chat') as string,
  },
  [MessageType.END_LIVE_CHAT]: {
    [ResolutionType.YES]: Locale.i18n.t('global.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.no') as string,
  },
  [MessageType.END_VOICE_CALL]: {
    [ResolutionType.YES]: Locale.i18n.t('global.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.no') as string,
  },
  [MessageType.RESTART_CHAT_RESOLUTION]: {
    [ResolutionType.YES]: Locale.i18n.t('global.yes') as string,
    [ResolutionType.NO]: Locale.i18n.t('global.no') as string,
  },
  [MessageType.USER_LOGIN_FROM_AI]: {
    [ResolutionType.YES]: Locale.i18n.t('page.login.button.login') as string,
    [ResolutionType.NO]: Locale.i18n.t('chat.sys.msg.ai.cannot_login') as string,
  },
};

export const RESOLUTION_OPTIONS_POSITION: Partial<Record<ResolutionMessageType, 'flex-row' | 'flex-col'>> = {
  [MessageType.RESOLUTION]: 'flex-row',
  [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: 'flex-col',
  [MessageType.STALE_AI_CONVERSATION_RESOLUTION]: 'flex-col',
  [MessageType.VOICE_CONFIRMATION]: 'flex-row',
  [MessageType.LANDING_AI_VOICE_CONFIRMATION]: 'flex-row',
  [MessageType.VOICE_NATIVE_MICRO_ACCESS_CONFIRMATION]: 'flex-row',
  [MessageType.CANCEL_REQUEST]: 'flex-row',
  [MessageType.END_LIVE_CHAT]: 'flex-row',
  [MessageType.END_VOICE_CALL]: 'flex-row',
  [MessageType.RESTART_CHAT_RESOLUTION]: 'flex-row',
};

export const DEFAULT_RESOLUTION_OPTIONS_ORDER: ResolutionKind[] = [ResolutionType.YES, ResolutionType.NO];

export const RESOLUTION_OPTIONS_ORDER: Partial<Record<ResolutionMessageType, ResolutionKind[]>> = {
  [MessageType.LANDING_AI_VOICE_CONFIRMATION]: [ResolutionType.NO, ResolutionType.YES],
};
